import {message} from 'antd';
import { Messages } from '../CommonMessages';

const AdnMessageError=(text=Messages.OperationError)=> {
  return message.error(text);
}

export default AdnMessageError;
